import React from 'react'
import LogoSvg from '../../../assets/logo.svg'
import LogoWhiteSvg from '../../../assets/logo-white.svg'
import Image from '../Image'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'

const StyledImage = styled(Image)`
  width: 112px;
  height: 57px;

  @media ${device.tablet} {
    width: 112px;
    height: 57px;
  }

  @media ${device.laptopM} {
    ${'' /* width: 132px;
    height: 67px; */}
    width: 6.875vw;
    height: 3.4895833333333335vw;
  }
`

const Logo = ({ white }) => {
  return (
    <a href="https://noleggiocampi.it/">
      <StyledImage src={white ? LogoWhiteSvg : LogoSvg} alt='logo' />
    </a>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/UI/Logo/index.js